import script from "./LoginPro.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPro.vue?vue&type=script&setup=true&lang=js"

import "./LoginPro.vue?vue&type=style&index=0&id=2c87c966&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c87c966"]])

export default __exports__